import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import theme from '../theme';
import { Card, Money, Spinner, Badge } from '../components/common';

export default function Accounts() {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/accounts').then(setAccounts).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: '60px' }}><Spinner size={32} /></div>;

  return (
    <div>
      <h1 style={{ fontSize: '20px', marginBottom: '20px' }}>Accounts</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {accounts.map(acc => (
          <Card key={acc.id} onClick={() => navigate(`/accounts/${acc.id}`)} style={{ cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px' }}>
              <div>
                <div style={{ fontSize: '15px', fontWeight: 600, marginBottom: '4px' }}>{acc.name}</div>
                <div style={{ fontSize: '13px', color: theme.colors.textLight, fontFamily: theme.fonts.mono }}>{acc.accountNumber}</div>
                <Badge color={acc.status === 'ACTIVE' ? 'success' : 'default'} style={{ marginTop: '8px' }}>{acc.status}</Badge>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '12px', color: theme.colors.textMuted }}>Available</div>
                <div style={{ fontSize: '20px', fontWeight: 700, color: theme.colors.primary }}>
                  <Money amount={acc.balance?.available || 0} currency={acc.currency} />
                </div>
                <div style={{ fontSize: '12px', color: theme.colors.textMuted, marginTop: '4px' }}>
                  Posted: <Money amount={acc.balance?.posted || 0} currency={acc.currency} />
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
